<div class="container">
    <div class="main">
        <div class="title">
            {{ 'port-settings.dialog.title' | translate }}
        </div>
        <div class="column-container">
            <div class="input-container">
                <div class="input-title">
                    {{ 'port-settings.dialog.name' | translate }}
                </div>
                <app-input-with-error
                    [inputValue]="port[NAME_INPUT]"
                    placeholder="port-settings.dialog.name"
                    [showLegend]="false"
                    [propertyName]="NAME_INPUT"
                    [validatorFunction]="validatorFunction()"
                    (onInputUpdated)="onInputChange({ value: $event, name: NAME_INPUT })"
                    maxlength="40">
                </app-input-with-error>
            </div>

            <div class="input-container">
                <div class="input-title">
                    {{ 'port-settings.dialog.communication-protocol' | translate }}
                </div>
                <app-simple-dropdown
                    style="height: 56px"
                    [options]="protocolOptions"
                    [selectedOption]="portProtocolName"
                    (onOptionSelected)="handleProtocolChanged($event)">
                </app-simple-dropdown>

                <div class="row-container">
                    <div class="input-title" style="color: #000">
                        {{ 'port-settings.dialog.protocol-type' | translate }}
                    </div>

                    <div class="simple-text">{{ protocolType | translate }}</div>
                </div>
            </div>

            <ng-container *ngIf="showExtraOptions">
                <div class="options-row">
                    <div class="options-title">
                        {{ 'port-settings.dialog.timeout' | translate }}
                    </div>
                    <app-input-with-error
                        style="flex: 1"
                        [showLegend]="false"
                        [isNumberInput]="true"
                        [inputValue]="port[TIMEOUT_INPUT]"
                        placeholder="port-settings.dialog.timeout"
                        [propertyName]="TIMEOUT_INPUT"
                        [validatorFunction]="validatorFunction()"
                        unitText="dlg.unit.ms"
                        (onInputUpdated)="onInputChange({ value: $event, name: TIMEOUT_INPUT })"
                        maxlength="40">
                    </app-input-with-error>
                </div>

                <div class="options-row">
                    <div class="options-title">
                        {{ 'port-settings.dialog.retry' | translate }}
                    </div>
                    <app-input-with-error
                        style="flex: 1"
                        [showLegend]="false"
                        [isNumberInput]="true"
                        [inputValue]="port[RETRY_INPUT]"
                        placeholder="port-settings.dialog.retry"
                        [propertyName]="RETRY_INPUT"
                        [validatorFunction]="validatorFunction()"
                        (onInputUpdated)="onInputChange({ value: $event, name: RETRY_INPUT })"
                        maxlength="40">
                    </app-input-with-error>
                </div>

                <div class="options-row">
                    <div class="options-title">
                        {{ 'port-settings.dialog.polling' | translate }}
                    </div>
                    <app-input-with-error
                        style="flex: 1"
                        [showLegend]="false"
                        [isNumberInput]="true"
                        [inputValue]="port[POLLING_INPUT]"
                        placeholder="port-settings.dialog.polling"
                        [propertyName]="POLLING_INPUT"
                        [validatorFunction]="validatorFunction()"
                        unitText="dlg.unit.ms"
                        (onInputUpdated)="onInputChange({ value: $event, name: POLLING_INPUT })"
                        maxlength="40">
                    </app-input-with-error>
                </div>
            </ng-container>
        </div>

        <div class="column-container">
            <div class="options-row options-title">
                <div class="input-title">
                    {{ 'port-settings.dialog.redundancy' | translate }}
                </div>
                <mat-slide-toggle class="toggle" [(ngModel)]="port.redundancy" (change)="redundacyUpdated()">
                </mat-slide-toggle>

                <div>
                    <ng-container *ngIf="!port.redundancy">
                        {{ 'dlg.disabled' | translate }}
                    </ng-container>
                    <ng-container *ngIf="port.redundancy">
                        {{ 'dlg.enabled' | translate }}
                    </ng-container>
                </div>
            </div>

            <ng-container *ngIf="port.redundancy">
                <div class="options-row">
                    <div class="keyword-title options-title">
                        {{ 'port-settings.dialog.redundancy.type' | translate }}
                    </div>

                    <div class="option-toggle-container">
                        <mat-radio-group
                            class="option-row"
                            [value]="port.redundancyType"
                            (change)="port.redundancyType = $event.value">
                            @for (option of redundancyTypeOptions; track option.value) {
                                <mat-radio-button [value]="option.value">
                                    {{ option.labelKey | translate }}
                                </mat-radio-button>
                            }
                        </mat-radio-group>
                    </div>
                </div>
                <div class="options-row">
                    <div class="keyword-title options-title">
                        {{ 'port-settings.dialog.redundancy.paired.unit' | translate }}
                    </div>
                    <app-simple-dropdown
                        style="height: 56px; flex: 1"
                        [options]="redundancyUnitOptions"
                        [selectedOption]="port.redundancyUnitId"
                        [isDisabled]="!port.redundancyType"
                        (onOptionSelected)="handleRedundacyUnitChanged($event)">
                    </app-simple-dropdown>
                </div>
                <div class="options-row">
                    <div class="keyword-title options-title">
                        {{ 'port-settings.dialog.redundancy.paired.port' | translate }}
                    </div>
                    <app-simple-dropdown
                        style="height: 56px; flex: 1"
                        [options]="redundancyIndexOptions"
                        [selectedOption]="port.redundancyPortIndex"
                        [isDisabled]="!port.redundancyUnitId"
                        (onOptionSelected)="handleRedundacyPortChanged($event)">
                    </app-simple-dropdown>
                </div>
            </ng-container>
        </div>

        <ng-container *ngIf="isSerialPort">
            <div class="column-container">
                <div class="subtitle">
                    {{ 'port-settings.dialog.serial-settings.title' | translate }}
                </div>
                <div class="options-row">
                    <div class="options-title">
                        {{ 'port-settings.dialog.serial-settings.baud-rate' | translate }}
                    </div>
                    <app-input-select-with-error
                        style="flex: 1"
                        [initialValue]="port.serialPortSetting?.[BAUD_RATE_INPUT]"
                        [propertyName]="BAUD_RATE_INPUT"
                        [optionsArray]="baudRateOptionsArray"
                        [maxLength]="10"
                        [placeholder]="'port-settings.dialog.serial-settings.baud-rate'"
                        (onInputUpdated)="selectBaudRate($event)"
                        [validatorFunction]="serialPortValidator()"
                        [isNumber]="true"
                        [emitOnInput]="true"
                        [removeBackground]="true">
                    </app-input-select-with-error>
                </div>

                <div class="options-row">
                    <div class="keyword-title options-title">
                        {{ 'port-settings.dialog.serial-settings.parity-bit' | translate }}
                    </div>
                    <app-simple-dropdown
                        style="height: 56px; flex: 1"
                        [options]="parityBitOptions"
                        [selectedOption]="port.serialPortSetting?.parityBit"
                        (onOptionSelected)="port.serialPortSetting.parityBit = $event.value">
                    </app-simple-dropdown>
                </div>

                <div class="options-row">
                    <div class="keyword-title options-title">
                        {{ 'port-settings.dialog.serial-settings.stop-bit' | translate }}
                    </div>
                    <app-simple-dropdown
                        style="height: 56px; flex: 1"
                        [options]="stopBitOptions"
                        [selectedOption]="port.serialPortSetting?.stopBit"
                        (onOptionSelected)="port.serialPortSetting.stopBit = $event.value">
                    </app-simple-dropdown>
                </div>

                <div class="options-row">
                    <div class="keyword-title options-title">
                        {{ 'port-settings.dialog.serial-settings.data-bit' | translate }}
                    </div>
                    <app-simple-dropdown
                        style="height: 56px; flex: 1"
                        [options]="dataBitOptions"
                        [selectedOption]="port.serialPortSetting?.dataBit"
                        (onOptionSelected)="port.serialPortSetting.dataBit = $event.value">
                    </app-simple-dropdown>
                </div>

                <div class="options-row">
                    <div class="keyword-title options-title">
                        {{ 'port-settings.dialog.serial-settings.duplex' | translate }}
                    </div>
                    <app-simple-dropdown
                        style="height: 56px; flex: 1"
                        [options]="duplexOptions"
                        [selectedOption]="port.serialPortSetting?.duplex"
                        (onOptionSelected)="port.serialPortSetting.duplex = $event.value">
                    </app-simple-dropdown>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="isLanPort">
            <div class="column-container">
                <div class="subtitle">
                    {{ 'port-settings.dialog.lan-settings.title' | translate }}
                </div>

                <div class="options-row">
                    <div class="keyword-title options-title">
                        {{ 'port-settings.dialog.lan-settings.local-ip' | translate }}
                    </div>
                    <app-input-with-error
                        style="flex: 1"
                        [showLegend]="false"
                        [inputValue]="port.lanPortSetting?.[LOCAL_IP_INPUT]"
                        placeholder="port-settings.dialog.lan-settings.local-ip"
                        [propertyName]="LOCAL_IP_INPUT"
                        [validatorFunction]="lanPortValidator()"
                        (onInputUpdated)="onInputChange({ value: $event, name: LOCAL_IP_INPUT })"
                        maxlength="40">
                    </app-input-with-error>
                </div>

                <div class="options-row">
                    <div class="keyword-title options-title">
                        {{ 'port-settings.dialog.lan-settings.remote-ip' | translate }}
                    </div>
                    <app-input-with-error
                        style="flex: 1"
                        [showLegend]="false"
                        [inputValue]="port.lanPortSetting?.[REMOTE_IP_INPUT]"
                        placeholder="port-settings.dialog.lan-settings.remote-ip"
                        [propertyName]="REMOTE_IP_INPUT"
                        [validatorFunction]="lanPortValidator()"
                        (onInputUpdated)="onInputChange({ value: $event, name: REMOTE_IP_INPUT })"
                        maxlength="40">
                    </app-input-with-error>
                </div>

                <div class="options-row">
                    <div class="keyword-title options-title">
                        {{ 'port-settings.dialog.lan-settings.remote-port' | translate }}
                    </div>
                    <app-input-with-error
                        style="flex: 1"
                        [showLegend]="false"
                        [isNumberInput]="true"
                        [inputValue]="port.lanPortSetting?.[REMOTE_PORT_INPUT]"
                        placeholder="port-settings.dialog.lan-settings.remote-port"
                        [propertyName]="REMOTE_PORT_INPUT"
                        [validatorFunction]="lanPortValidator()"
                        (onInputUpdated)="onInputChange({ value: $event, name: REMOTE_PORT_INPUT })"
                        maxlength="40">
                    </app-input-with-error>
                </div>
            </div>
        </ng-container>

        <div class="column-container">
            <div class="protocol-settings-button">
                <app-button
                    [disable]="!port?.protocol?.protocolId || !hasProtocolDialog"
                    text="port-settings.dialog.open-protocol-settings"
                    customFontFamily="NotoSans-SemiBold"
                    size="small"
                    customFontSize="14px"
                    (onClick)="openProtocolSettings()"></app-button>
            </div>
        </div>
    </div>

    <div class="footer">
        <button class="text-button" (click)="closeDialog()">
            {{ 'dlg.cancel' | translate }}
        </button>
        <app-button
            [disable]="isSaveDisabled"
            text="dlg.save"
            customFontFamily="NotoSans-SemiBold"
            size="small"
            customFontSize="14px"
            (onClick)="save()"></app-button>
    </div>
</div>
